// eslint-disable-next-line import/prefer-default-export
export const DATE_FORMAT = 'YYYY-MM-Do hh:mm:ss';
